<template>
  <div style="width: 100%; height: 100%; padding: 0 10px">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        label="资质资料填写"
        name="zz"
        v-if="Grade == '1' || Grade == '3'"
      >
      </el-tab-pane>
      <el-tab-pane label="项目资料填写" name="xm" v-if="Grade == '1'">
      </el-tab-pane>

      <el-tab-pane label="设备资料填写" name="sb"></el-tab-pane>
      <el-tab-pane label="通用配件填写" name="bj"></el-tab-pane>
    </el-tabs>
    <TemplateProjeactFill
      ref="TemplateProjeactFill"
      v-if="activeName === 'xm'"
    ></TemplateProjeactFill>
    <TemplateForm ref="TemplateForm" v-if="activeName === 'sb'"></TemplateForm>
    <TemplateCertification
      ref="TemplateCertification"
      v-if="activeName === 'zz'"
    ></TemplateCertification>
    <TemplateSpares
      ref="TemplateSpares"
      v-if="activeName === 'bj'"
    ></TemplateSpares>
  </div>
</template>
<script>
import TemplateProjeactFill from './TemplateProjeactFill.vue'
import TemplateForm from './TemplateForm.vue'
import TemplateCertification from './TemplateCertification.vue'
import TemplateSpares from './TemplateSpares.vue'
export default {
  data() {
    return {
      activeName: '',
      Grade: '',
    }
  },
  props: {},
  components: {
    TemplateProjeactFill,
    TemplateForm,
    TemplateCertification,
    TemplateSpares,
  },
  methods: {
    handleClick() {},
  },
  mounted() {},
  created() {
    this.Grade = window.localStorage.getItem('Grade') || null
    // if (this.Grade == '1') {
    //   this.activeName = 'sb'
    // } else if (this.Grade == '2') {
    //   this.activeName = 'sb'
    // }
    this.activeName = 'sb'
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped></style>
